<script setup lang="ts">
const contacts = [
  {
    label: 'Email',
    value: 'dev.hardiyanto@gmail.com',
    href: 'mailto:dev.hardiyanto@gmail.com',
    icon: 'i-lucide-mail',
    external: false
  },
  {
    label: 'WhatsApp',
    value: '+62 895 1210 7412',
    href: 'https://wa.me/6289512107412',
    icon: 'i-lucide-phone',
    external: true
  }
]

const socials = [
  { label: 'GitHub', href: 'https://github.com/devhardiyanto', icon: 'i-simple-icons-github' },
  { label: 'LinkedIn', href: 'https://linkedin.com/in/ihardiyanto', icon: 'i-simple-icons-linkedin' }
]
</script>

<template>
  <section
    id="contact"
    class="py-12 pb-16"
  >
    <h2 class="text-xs font-semibold uppercase tracking-widest text-muted mb-6">
      Get In Touch
    </h2>

    <div class="grid sm:grid-cols-2 gap-4">
      <a
        v-for="contact in contacts"
        :key="contact.label"
        :href="contact.href"
        :target="contact.external ? '_blank' : undefined"
        class="flex items-center gap-3 p-4 rounded-xl border border-default bg-elevated hover:border-zinc-600 transition-colors group"
      >
        <div class="size-9 rounded-lg bg-zinc-800 flex items-center justify-center shrink-0">
          <UIcon
            :name="contact.icon"
            class="size-4 text-primary"
          />
        </div>
        <div>
          <p class="text-sm text-muted">{{ contact.label }}</p>
          <p class="text-base font-medium text-highlighted group-hover:text-primary transition-colors">
            {{ contact.value }}
          </p>
        </div>
      </a>
    </div>

    <div class="flex items-center gap-2 mt-4">
      <UButton
        v-for="social in socials"
        :key="social.label"
        :to="social.href"
        target="_blank"
        :icon="social.icon"
        :aria-label="social.label"
        variant="outline"
        size="sm"
      />
      <p class="text-sm text-muted ml-2">
        Rahayu Village, Margaasih, West Java · Open to remote
      </p>
    </div>
  </section>
</template>
